import API from '../../services/api';
import { useCallback, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function useInterview() {
  const navigate = useNavigate();

  const fetchQuestionsBank = async (search = '', page = 1, pageSize = 10) => {
    try {
      const response = await API.get(
        `/interviews/questions/?question=${encodeURIComponent(
          search,
        )}&page=${page}&page_size=${pageSize}`,
      );
      return {
        success: true,
        data: response.data, // ✅ actual data returned
      };
    } catch (err) {
      const errorMsg =
        err.response?.data?.error ||
        err.response?.data?.detail ||
        'Failed to fetch questions.';
      return {
        success: false,
        error: errorMsg,
      };
    }
  };

  const fetchOneQuestion = useCallback(async (uuid) => {
    try {
      const { data } = await API.get(`/interviews/questions/${uuid}/`);
      return { success: true, data };
    } catch (err) {
      const msg =
        err.response?.data?.error ||
        err.response?.data?.detail ||
        'Fetch failed.';
      return { success: false, message: msg };
    }
  }, []);

  const updateOneQuestion = async (uuid, data) => {
    // PATCH is partial: omit type/skills when not provided so the
    // question keeps its existing type (e.g. DYNAMIC_FOLLOWUP) and skills
    const formattedData = {
      name: data.QuestionName,
      body: data.QuestionBody,
    };
    if (data.type) {
      formattedData.type = data.type;
    }
    if (data.skills !== undefined) {
      formattedData.skills = data.skills;
    }

    console.log('Updating question:', formattedData);

    try {
      const response = await API.patch(
        `/interviews/questions/${uuid}/`,
        formattedData,
      );
      return response.data; // whatever your API returns
    } catch (err) {
      // bubble up the server’s error payload if available
      throw err.response?.data || err;
    }
  };

  const postquestions = async (data) => {
    // const type1 = "a9c95b39-d025-4693-87cb-132034e65eab";
    // const type1 = "b8173431-c651-4582-ae9e-5dbd15abe966";
    const type1 = 'daff45d7-24a2-49e9-9cec-9d44eb56746b';
    const formattedData = {
      name: data.QuestionName,
      type: data.type || type1,
      body: data.QuestionBody,
      skills: [],
    };

    console.log(formattedData);

    try {
      const response = await API.post(`/interviews/questions/`, formattedData);
      return response.data;
    } catch (err) {
      throw err.response?.data || err;
    }
  };

  const deleteOneQuestion = async (uuid) => {
    try {
      await API.delete(`/interviews/questions/${uuid}/`);
      return { success: true };
    } catch (err) {
      return {
        success: false,
        message:
          err.response?.data?.detail ||
          err.response?.data?.error ||
          err.message,
      };
    }
  };

  const fetchQuestionsInterview = async (
    search = '',
    page = 1,
    pageSize = 5,
    uuid,
  ) => {
    try {
      const response = await API.get(
        `/interviews/interviews/${uuid}/questions/`,
      );
      return {
        success: true,
        data: response.data, // ✅ actual data returned
      };
    } catch (err) {
      const errorMsg =
        err.response?.data?.error ||
        err.response?.data?.detail ||
        'Failed to fetch questions.';
      return {
        success: false,
        error: errorMsg,
      };
    }
  };

  const postinterviews = async (data) => {
    // const type1 = "a0135e43-36d4-44e1-841d-0a2da94a7fac";
    // const type1 = "1303a79e-c033-4266-ac96-8c9565a0ca46";
    const type1 = 'ddb62ee1-f6e3-43cc-8fa0-dfbc7f3bdb81';
    const formattedData = {
      name: data.InterviewName,
      type: type1,
      description: data.InterviewDescription,
    };

    console.log(formattedData);

    try {
      const response = await API.post(`/interviews/interviews/`, formattedData);
      return response.data;
    } catch (err) {
      throw err.response?.data || err;
    }
  };

  const fetchInterviews = async () => {
    try {
      const response = await API.get(`/interviews/interviews/`);
      return {
        success: true,
        data: response.data, // ✅ actual data returned
      };
    } catch (err) {
      const errorMsg =
        err.response?.data?.error ||
        err.response?.data?.detail ||
        'Failed to fetch questions.';
      return {
        success: false,
        error: errorMsg,
      };
    }
  };

  const fetchOneInterview = useCallback(async (uuid) => {
    try {
      const { data } = await API.get(`/interviews/interviews/${uuid}/`);
      return { success: true, data };
    } catch (err) {
      const msg =
        err.response?.data?.error ||
        err.response?.data?.detail ||
        'Fetch failed.';
      return { success: false, message: msg };
    }
  }, []);

  const updateOneInterview = async (uuid, data) => {
    // re-use your same type constant (or pull it from data if it varies)
    const type1 = 'ddb62ee1-f6e3-43cc-8fa0-dfbc7f3bdb81';

    const formattedData = {
      name: data.InterviewName,
      type: type1,
      description: data.InterviewDescription,
    };

    console.log('Updating Interview:', formattedData);

    try {
      const response = await API.patch(
        `/interviews/interviews/${uuid}/`,
        formattedData,
      );
      return response.data; // whatever your API returns
    } catch (err) {
      // bubble up the server’s error payload if available
      throw err.response?.data || err;
    }
  };

  const deleteOneInterview = async (uuid) => {
    try {
      await API.delete(`/interviews/interviews/${uuid}/`);
      return { success: true };
    } catch (err) {
      return {
        success: false,
        message:
          err.response?.data?.detail ||
          err.response?.data?.error ||
          err.message,
      };
    }
  };

  const addOneQuestiontoInterview = async (interviewId, questionId) => {
    const formattedData = {
      interview: interviewId,
      question: questionId,
    };

    try {
      const response = await API.post(
        `/interviews/interview_questions/`,
        formattedData,
      );
      return response.data;
    } catch (err) {
      throw err.response?.data || err;
    }
  };

  const deleteOneQuestionfromInterview = async (uuid) => {
    try {
      await API.delete(`/interviews/interview_questions/${uuid}/`);
      return { success: true };
    } catch (err) {
      return {
        success: false,
        message:
          err.response?.data?.detail ||
          err.response?.data?.error ||
          err.message,
      };
    }
  };

  return {
    fetchQuestionsBank,

    postquestions,
    fetchOneQuestion,
    updateOneQuestion,
    deleteOneQuestion,
  };
}
